import React, { useState } from "react";
import { IoMdSend } from "react-icons/io";
import CircularProgress from "@mui/material/CircularProgress";
import styled from "styled-components";

export default function ChatInput({
  handleSendMsg,
  sendMessageAPI,
  sendMessageLoading,
}) {
  const [msg, setMsg] = useState("");

  const sendChat = async (event) => {
    event.preventDefault();
    let forSending = msg.trim();
    if (forSending.length > 0) {
      setMsg("");
      await sendMessageAPI(forSending);
    }
  };

  const handleKeyPress = (e) => {
    if (e.key === "Enter" && !e.shiftKey && sendMessageLoading === false) {
      e.preventDefault();
      sendChat(e);
    }
  };
  return (
    <Container className="chat-input">
      <form className="input-container" onSubmit={(event) => sendChat(event)}>
        <textarea
          type="text"
          placeholder="type your message here"
          onChange={(e) => setMsg(e.target.value)}
          onKeyPress={handleKeyPress}
          value={msg}
        />
      </form>

      <button
        type="submit"
        id="send-btn"
        onClick={(event) => sendChat(event)}
        disabled={sendMessageLoading}
      >
        {/* {sendMessageLoading ? (
          <CircularProgress sx={{ fontSize: "20px" }} />
        ) : (
          <> */}
            <IoMdSend />
          {/* </>
        )} */}
      </button>
    </Container>
  );
}

const Container = styled.div`
  display: grid;
  align-items: center;
  width: 100%;
  grid-template-columns: 90% 10%;
  background-color: #080420;
  padding: 0 2rem;
  @media screen and (min-width: 720px) and (max-width: 1080px) {
    padding: 0 1rem;
    gap: 1rem;
  }
  .input-container {
    width: 100%;
    border-radius: 8rem;
    background-color: #ffffff34;
    display: flex;
    align-items: center;
    justify-content: center;
    textarea {
      width: 90%;
      resize: none;
      height: 45px;
      background-color: transparent;
      color: white;
      overflow: hidden;
      border: none;
      font-size: 1.2rem;
      padding: 3px;
      margin-top: 8px;
      box-sizing: border-box;
      &::selection {
        background-color: #9a86f3;
      }
      &:focus {
        outline: none;
      }
    }
  }
  #send-btn {
    border-radius: 10px;
    float: right;
    height: 50px;
    background-color: #9a86f3;
    border: none;
    cursor: pointer;
    margin-right: 0px;
    @media screen and (min-width: 720px) and (max-width: 1080px) {
      // padding: 0.3rem 1rem;
      svg {
        font-size: 1rem;
      }
    }
    svg {
      font-size: 2rem;
      color: white;
    }
  }
  #attachment-btn {
    border-radius: 10px;
    float: right;
    height: 50px;
    margin-left: 3px;
    margin-right: 3px;
    background-color: #9a86f3;
    border: none;
    @media screen and (min-width: 720px) and (max-width: 1080px) {
      // padding: 0.3rem 1rem;
      svg {
        font-size: 1rem;
      }
    }
    svg {
      font-size: 2rem;
      color: white;
    }
  }
`;
